import { SB } from '@play-co/replicant';

export const userSettingsSchema = SB.object({
  locale: SB.string(),
  receiveMessages: SB.tuple(['on', 'less', 'off']).default('on'),
  music: SB.boolean().default(true),
  sound: SB.boolean().default(true),
});
